<template>
  <div class="modal custom-modal fade" id="addcustomer_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <form @submit.prevent="onSubmit" class="modal-content">
        <div class="modal-header border-0 pb-0">
          <div class="form-header modal-header-title text-start mb-0">
            <h4 class="mb-0">Add Customer</h4>
          </div>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span class="align-center" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="form-group">
              <label>Full Name</label>
              <input
                type="text"
                class="form-control"
                v-model="form.name"
                placeholder="Enter Name"
                required
              />
            </div>
            <div class="form-group">
              <label>Email</label>
              <input
                type="text"
                v-model="form.email"
                class="form-control"
                placeholder="Enter Your Email"
                required
              />
            </div>

            <div
              :class="{
                'col-lg-6': !useforwhatsapp,
                'col-lg-12': useforwhatsapp,
              }"
            >
              <div class="form-group">
                <label>Phone</label>
                <input
                  type="tel"
                  v-model="form.phone"
                  @input="getFormattedNumber"
                  ref="phoneInputRef"
                  class="form-control"
                  id="phone"
                  placeholder="Your phone number"
                />
              </div>
            </div>

            <div v-if="!useforwhatsapp" class="col-lg-6 col-md-12">
              <div class="form-group">
                <label>WhatsApp Number</label>
                <input
                  type="tel"
                  v-model="form.whatsapp_number"
                  @input="getFormattedWhatsappNumber"
                  ref="whatsappInputRef"
                  class="form-control"
                  id="phone"
                  placeholder="Your WhatsApp number"
                />
              </div>
            </div>

            <div class="form-group mb-0">
              <label class="custom_check me-3" style="color: #878a99">
                <input
                  type="checkbox"
                  @click="OpenWat"
                  v-model="useforwhatsapp"
                  name="whatsapp"
                />
                <span class="checkmark"></span> Use for WhatsApp
              </label>
            </div>

            <div class="form-group notes-form-group">
              <label>Address</label>
              <textarea
                class="form-control"
                v-model="form.address"
                placeholder="Enter Your Address"
              ></textarea>
            </div>

            <p class="mb-3 fw-bold text-dark">Optional</p>

            <div class="row">
              <div class="col-lg-6 col-md-12">
                <div class="form-group">
                  <label>Website</label>
                  <input
                    type="text"
                    v-model="form.website"
                    class="form-control"
                    placeholder="Enter Your website"
                  />
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <div class="form-group">
                  <label>Category</label>
                  <select class="form-select" v-model="form.category">
                    <option disabled value="">Category</option>
                    <option
                      v-for="(category, index) in categories"
                      :key="index"
                      :value="category"
                    >
                      {{ category }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-12">
                <div class="form-group">
                  <label>Country</label>
                  <select class="form-select" v-model="form.country">
                    <option disabled value="">Country</option>
                    <option
                      v-for="(country, index) in Countries"
                      :key="index"
                      :value="country.isoCode"
                    >
                      {{ country.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <div class="form-group">
                  <label>State</label>
                  <select class="form-select" v-model="form.state">
                    <option disabled value="">State</option>
                    <option
                      v-for="(state, index) in States"
                      :key="index"
                      :value="state.name"
                    >
                      {{ state.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer add-tax-btns">
          <a
            href="javascript:;"
            data-bs-dismiss="modal"
            class="btn add-btn-cancel-btn"
            >Cancel</a
          >
          <button type="submit" :disabled="isLoading" class="btn btn-primary">
            <span
              v-if="isLoading"
              class="spinner-border spinner-border-sm me-1"
              role="status"
              aria-hidden="true"
            ></span>
            <span v-if="!isLoading">Add Customer</span>
            <span v-if="isLoading">Saving...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed,watch } from "vue";
import { useStore } from "vuex";
import { Country, State } from "country-state-city";
import intlTelInput from "intl-tel-input";

const Countries = ref(null);
const isLoading = ref(false);
const store = useStore();
const categories = ["Business", "Agriculture", "Finance", "Education"];
const useforwhatsapp = ref(true);
const phoneInputRef = ref(null);
const whatsappInputRef = ref(null);
let iti;

const emit = defineEmits(["closeAddModal"]);

const form = ref({
  name: "",
  address: "",
  email: "",
  phone: "",
  country_code: "",
  whatsapp_number: "",
  website: "",
  address: "",
  category: "",
  country: "",
  state: "",
});

watch(useforwhatsapp, (newValue) => {
  if (newValue === true) {
    form.value.whatsapp_number = "";
  }
});
// Formating the phone number
const getFormattedNumber = () => {
  if (iti) {
    const formattedNumber = iti.getSelectedCountryData();
    form.value.country_code = `+${formattedNumber.dialCode}`;

    const firstDigit = form.value.phone.charAt(0);
    if (
      form.value.phone.length === 11 &&
      firstDigit != "+" &&
      firstDigit == "0"
    ) {
      form.value.phone = `${form.value.phone.slice(1)}`;
    } else if (form.value.phone.length === 11 && firstDigit != "+") {
      form.value.phone = `${form.value.phone}`;
    }
  }
};

// Formating the whatsapp number
const getFormattedWhatsappNumber = () => {
  if (iti) {

    const firstDigit = form.value.whatsapp_number.charAt(0);
    if (
      form.value.whatsapp_number.length === 11 &&
      firstDigit != "+" &&
      firstDigit == "0"
    ) {
      form.value.whatsapp_number = `${form.value.whatsapp_number.slice(1)}`;
    } else if (form.value.whatsapp_number.length === 11 && firstDigit != "+") {
      form.value.whatsapp_number = `${form.value.whatsapp_number}`;
    }
  }
};

const States = computed(() => {
  return State.getStatesOfCountry(form.value.country);
});

const getCustomers = () => {
  let data = {
    page: 1,
    per_page: 1000,
    query: "",
  };
  store.dispatch("customer/getCustomers", data);
};

const onSubmit = async () => {
  if (useforwhatsapp.value == true) {
    form.value.whatsapp_number = form.value.phone;
  }
  isLoading.value = true;
  await store
    .dispatch("customer/addCustomerFromEstimate", form.value)
    .then(() => {
      isLoading.value = false;
      emit("closeAddModal");
      form.value = {
        name: "",
        address: "",
        email: "",
        phone: "",
        website: "",
        address: "",
        category: "",
        country: null,
        state: null,
      };
      getCustomers();
    })
    .catch(() => {
      isLoading.value = false;
    });
};

onMounted(() => {
  Countries.value = Country.getAllCountries();

  iti = intlTelInput(phoneInputRef.value, {
    nationalMode: true,
    autoPlaceholder: "aggressive",
    formatOnDisplay: true,
    autoInsertDialCode: true,
    separateDialCode: true,
  });

  fetch("https://ipapi.co/json/")
    .then((response) => response.json())
    .then((data) => {
      const countryCode = data.country_code;
      iti.setCountry(countryCode);
    })
    .catch((error) => {
      console.error("Error fetching IP data:", error);
    });
});
</script>
